<template>
  <el-dialog :title="select ? '查看' : isupload ? '编辑家属信息' : '新增家属信息'" :visible.sync="visible_v"
             width="1100px" @close="() => { $emit('cancel') }">
    <Form ref="addEmployess" :label-width="130" :model="formCustom" :rules="ruleValidate" inline>
      <Form-item label="姓：" prop="x">
        <Input v-model="formCustom.x" :disabled="select" clearable style="width: 200px"></Input>
      </Form-item>
      <Form-item label="名：" prop="m">
        <Input v-model="formCustom.m" :disabled="select" clearable style="width: 200px"></Input>
      </Form-item>
      <Form-item label="姓名：" prop="xm">
        <Input v-model="formCustom.xm" :disabled="select" clearable style="width: 200px"></Input>
      </Form-item>
      <Form-item label="国籍：" prop="gj">
        <el-select v-model="formCustom.gj" :disabled="select" filterable placeholder="请选择">
          <el-option v-for="item in countryArr" :key="item.id" :label="item.Chinese" :value="item.Chinese">
          </el-option>
        </el-select>
      </Form-item>
      <Form-item label="出生地点：" prop="csdd">
        <Input v-model="formCustom.csdd" :disabled="select" clearable style="width: 200px"></Input>
      </Form-item>
      <Form-item label="出生年月日：" prop="csnyr">
        <DatePicker :disabled="select" :value="formCustom.csnyr" format="yyyy-MM-dd" style="width: 200px" type="date"
                    @on-change="changecsnyr"/>
      </Form-item>
      <Form-item label="家属类型：" prop="jslx">
        <el-select v-model="formCustom.jslx" :disabled="select" placeholder="请选择">
          <el-option value="子女">
          </el-option>
          <el-option value="配偶">
          </el-option>
          <el-option value="父母">
          </el-option>
        </el-select>
      </Form-item>
      <Form-item label="护照号码：" prop="hzhm">
        <Input v-model="formCustom.hzhm" :disabled="select" clearable style="width: 200px"></Input>
      </Form-item>
      <Form-item label="护照到期日：" prop="hzdqrq">
        <DatePicker :disabled="select" :value="formCustom.hzdqrq" format="yyyy-MM-dd" style="width: 200px"
                    type="date" @on-change="changehzdqrq"/>
      </Form-item>
      <Form-item label="居留许可证编号：" prop="jlxkzbh">
        <Input v-model="formCustom.jlxkzbh" :disabled="select" clearable style="width: 200px"></Input>
      </Form-item>
      <Form-item label="居留许可证签发日期：" prop="jlxkzqfrq">
        <DatePicker :disabled="select" :value="formCustom.jlxkzqfrq" format="yyyy-MM-dd" style="width: 200px"
                    type="date" @on-change="changejlxkzqfrq"/>
      </Form-item>
      <Form-item label="居留许可证到期日期：" prop="jlxkzdqrq">
        <DatePicker :disabled="select" :value="formCustom.jlxkzdqrq" format="yyyy-MM-dd" style="width: 200px"
                    type="date" @on-change="changejlxkzdqrq"/>
      </Form-item>
      <Form-item label="备注：">
        <Input v-model="formCustom.bz" :disabled="select" clearable style="width: 200px"></Input>
      </Form-item>
      <Form-item>
        <Button v-if="!select" :loading="addloading" style="margin-left: 480px;" type="primary" @click="add">
          确定
        </Button>
      </Form-item>
    </Form>

  </el-dialog>
</template>
<script>
import permissionList from "@/libs/handlePermission.ts";
import {employeeFamilyMemberAdd, employeeFamilyMemberPut} from '@/api/employee'

import {countryArr} from "./country";

export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      default: () => null
    },
    isupload: {
      type: Boolean,
      required: false
    },
    select: {
      type: Boolean,
      required: false
    },
  },
  watch: {
    visible(v) {
      console.log(v)
      this.visible_v = v
      if (v) {
        this.init()
      }
    }
  },
  name: "company",
  data() {
    const validatejlxkzqfrq = (rule, value, callback) => {
      if (!this.formCustom.jlxkzqfrq) {
        callback(new Error('请选择'));
      } else {
        callback();
      }
    }
    const validatejlxkzdqrq = (rule, value, callback) => {
      if (!this.formCustom.jlxkzdqrq) {
        callback(new Error('请选择'));
      } else {
        callback();
      }
    }
    const validatehzdqrq = (rule, value, callback) => {
      if (!this.formCustom.hzdqrq) {
        callback(new Error('请选择'));
      } else {
        callback();
      }
    }
    const validatecsnyr = (rule, value, callback) => {
      console.log(this.formCustom)
      if (!this.formCustom.csnyr) {
        callback(new Error('请选择'));
      } else {
        callback();
      }
    }
    return {
      tableData: '',
      loading: false,
      countryArr: countryArr,
      addloading: false,
      defaultValue: [],
      isShow: false,
      organization: '',
      formCustom: {
        evaluationItem: [],
        evaluationRole: [],
        organizationIdList: [],
        evaluationEmployeeIds: [],
        evaluationCategory: ''
      },
      visible_v: false,
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      value: '',
      options: [],
      organizationList: [], // 组织机构列表
      ruleValidate: {
        xm: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        gj: [
          {required: true, message: '请选择', trigger: 'blur'}
        ],
        csnyr: [
          {required: true, validator: validatecsnyr, trigger: 'blur'}
        ],
        jslx: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        hzhm: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        jlxkzbh: [
          {required: false}
        ],
        csdd: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        jlxkzqfrq: [
          {required: false}
        ],
        jlxkzdqrq: [
          {required: false}
        ],
        hzdqrq: [
          {required: true, validator: validatehzdqrq, trigger: 'blur'}
        ]
      }
    }
  },
  components: {},
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.init()
    this.roleType = user.roleType;
  },
  methods: {
    changecsnyr(t) {
      this.formCustom.csnyr = t
    },
    changehzdqrq(t) {
      this.formCustom.hzdqrq = t
    },
    changejlxkzqfrq(t) {
      this.formCustom.jlxkzqfrq = t
    },
    changejlxkzdqrq(t) {
      this.formCustom.jlxkzdqrq = t
    },
    init() {
      this.formCustom = this.model
    },
    add() {
      if (this.isupload) {
        this.addloading = true
        if (this.formCustom.jlxkzqfrq) {
          this.formCustom.jlxkzqfrq = this.$moment(this.formCustom.jlxkzqfrq).format("YYYY-MM-DD")
        }
        this.formCustom.csnyr = this.$moment(this.formCustom.csnyr).format("YYYY-MM-DD")
        let params = {...this.formCustom, employeeId: this.model.employeeId}
        if (this.model.employeeChangeLogId) params.employeeChangeLogId = this.model.employeeChangeLogId
        employeeFamilyMemberPut(params).then(res => {
          this.addloading = false
          if (res.data.success) {
            this.$emit('successadd')
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.addloading = false
          this.$message.error(error.response.data.msg);
        })
      } else {
        this.$refs.addEmployess.validate((valid) => {
          console.log(1)
          if (valid) {
            this.addloading = true
            this.formCustom.csnyr = this.$moment(this.formCustom.csnyr).format("YYYY-MM-DD")
            // this.formCustom.hzdqrq = this.$moment(this.formCustom.hzdqrq).format("YYYY-MM-DD")
            if (this.formCustom.jlxkzqfrq) {
              this.formCustom.jlxkzqfrq = this.$moment(this.formCustom.jlxkzqfrq).format("YYYY-MM-DD")
            }
            employeeFamilyMemberAdd({...this.formCustom, employeeId: this.model.employeeId}).then(res => {
              this.addloading = false
              if (res.data.success) {
                this.$emit('successadd')
                this.$message.success(res.data.msg);
              } else {
                this.$message.error(res.data.msg);
              }
            })
          }
        })
      }
    }
  }
}
</script>
<style>
.tips {
  color: #ff0000;
  width: 400px;
  margin-left: 650px;
}
</style>
